import HomePage from '@/views/home-manage/index'
import Datadeletion from '@/views/datadeletion-manage/index'
import Privacy from '@/views/privacy-manage/index.vue'
import UserAgreement from '@/views/user-agreement/index.vue'
import DownLoadPage from '@/views/download/index.vue'
import ComicSeriesPrivacy from '@/views/comic-series-privacy/index.vue'
import ComicSeries from '@/views/comic-series/index.vue'
import PaymentTerms from '@/views/payment-terms/index.vue'
import MerchantAgreementTermination from '@/views/merchant-agreement-termination/index.vue'
import EmailConfirmation from '@/views/email-confirmation/index.vue'
import BillingStatement from '@/views/billing-statement/index.vue'

export default [
  {
    path: '/',
    component: HomePage,
    name: 'Index',
    children: [],
  },
  {
    path: '/datadeletion',
    component: Datadeletion,
    name: 'datadeletion',
    children: [],
  },
  {
    path: '/privacy',
    component: Privacy,
    name: 'privacy',
    children: [],
  },
  {
    path: '/user-agreement',
    component: UserAgreement,
    name: 'UserAgreement',
    children: [],
  },
  {
    path: '/download',
    component: DownLoadPage,
    name: 'Download',
    children: [],
  },
  {
    path: '/comic-series',
    component: ComicSeries,
    name: 'ComicSeries',
    children: [],
  },
  {
    path: '/comic-series-privacy',
    component: ComicSeriesPrivacy,
    name: 'ComicSeriesPrivacy',
    children: [],
  },
  {
    path: '/payment-terms',
    component: PaymentTerms,
    name: 'PaymentTerms',
    children: [],
  },
  {
    path: '/merchant-agreement-termination',
    component: MerchantAgreementTermination,
    name: 'MerchantAgreementTermination',
    children: [],
  },
  {
    path: '/email-confirmation',
    component: EmailConfirmation,
    name: 'EmailConfirmation',
    children: [],
  },
  {
    path: '/billing-statement',
    component: BillingStatement,
    name: 'BillingStatement',
    children: [],
  },
]
